import { Component, Input, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { PathBreadcrumb, ToolTab } from '@/core/interfaces';
import { Subscription } from 'rxjs';
import { DataService, RouteService } from '@/shared/services';

@Component({
  selector: 'tool-header',
  templateUrl: './tool-header.component.html',
  styleUrl: './tool-header.component.css',
  standalone: false,
})
export class ToolHeaderComponent implements OnInit {
  @Input() headerTitle: string = '';
  @Input() subtitle: string = '';
  @Input() toolTabItems: ToolTab[] = [];
  @Input() helpPagePath: string = '';
  @Input() marginTop: string = '20px';
  @Input() pathBreadcrumbs: PathBreadcrumb[] = [];

  public env = environment;
  public dataPending!: boolean;
  private subscription: Subscription = new Subscription();

  constructor(
    private dataService: DataService,
    public routeService: RouteService,
  ) {}

  ngOnInit(): void {
    this.subscription.add(
      this.dataService.getPendingData().subscribe((pending) => {
        this.dataPending = pending;
      }),
    );
  }
}
